import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { BookSection } from '../components/BookSection';
import { ArticlesGrid } from '../components/ArticlesGrid';
import { MediaSection } from '../components/MediaSection';
import { ConsultingSection } from '../components/ConsultingSection';
import { TimelineSection } from '../components/TimelineSection';
import { WorkHistorySection } from '../components/WorkHistorySection';
import { ContactSection } from '../components/ContactSection';
export function HomePage() {
  // Enable smooth scrolling on the document level
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  // Set the browser tab title
  useEffect(() => {
    document.title = 'Arthur Miller';
  }, []);
  return <div className="min-h-screen bg-[#0B1120] font-sans text-white" data-id="element-276" data-mp="2ap4v2nkepl30">
      <Navigation data-id="element-277" data-mp="2amsfgh24fmt4" />

      <main data-id="element-278" data-mp="2eqgol46eiqgh">
        <HeroSection data-id="element-279" data-mp="2epyjrj5ob3wy" />
        <AboutSection data-id="element-280" data-mp="2epf283jxqhjg" />
        <BookSection data-id="element-281" data-mp="2eongrlk1y06w" />
        <ArticlesGrid data-id="element-282" data-mp="2eo3z85ybddte" />
        <MediaSection data-id="element-283" data-mp="2jhghzzgbaqe8" />
        <ConsultingSection data-id="element-284" data-mp="2ji87csjbfrw2" />
        <TimelineSection data-id="element-285" data-mp="2jhyp5r4iip0x" />
        <WorkHistorySection data-id="element-286" data-mp="2og9zs42mt3k7" />
      </main>

      <ContactSection data-id="element-287" data-mp="2of8d12c96smn" />
    </div>;
}